import { BASE_URL } from 'config/urls';

import { post, requestSdk } from 'utils/sdk';

export const customerAddCard = async (data) => {
  return await requestSdk(() =>
    post(`${BASE_URL}/v1/subscriptions/customer/add-card/`, data)
  );
};
